import { Outlet } from 'react-router-dom';
import { TopNav } from '@/components/layout/TopNav';
import { CommunitiesHeader } from '@/features/communities/my-communities/CommunitiesHeader';

/**
 * Shell for the Communities hub. Keeps the app's TopNav over the full-screen
 * themed backdrop and renders the active page full-width. (The old left rail was
 * removed — primary nav lives in the TopNav, and notifications now open from the
 * TopNav bell.)
 */
export function CommunityHubLayout() {
  return (
    <div className="min-h-screen">
      {/* Blur the themed backdrop behind the hub, matching the in-community view's
          frosted-glass treatment so the cards read against a soft surface. */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 bg-[linear-gradient(180deg,rgba(10,10,14,0.45),rgba(10,10,14,0.6))] backdrop-blur-[22px] backdrop-saturate-[1.3]"
      />
      <TopNav center={<CommunitiesHeader className="hidden sm:flex" />} sticky={false} />
      <main className="min-w-0 px-5 py-2 sm:px-8 sm:py-3">
        <Outlet />
      </main>
    </div>
  );
}
